import React from "react";
import BasicToolTip from "../tooltips/Tooltip";
import IconButton from "./IconButton";
import { IIconButtonWithTooltip } from "../../../interfaces/buttons/buttons";


const IconButtonWithTooltip = ({ ariaLabel, className, isDisabled = false, onButtonClick, iconName, tooltipText}: IIconButtonWithTooltip) => {   
    
    return (
        <div className={`app-icon-tooltip-wrapper`}>
            <BasicToolTip text={tooltipText} className={className}>
                <IconButton ariaLabel={ariaLabel} iconName={iconName} isDisabled={isDisabled} onButtonClick={onButtonClick}/>
            </BasicToolTip>
        </div>
    );
};

export default IconButtonWithTooltip;